import React from 'react';
import App from '../App/App';
import SolutionBanner from './SolutionBanner';
import {Cards, ImageLayer} from '../../components';
import MethodCard from './MethodCard';
import AdvantageCard from './AdvantageCard';
import data from './config';

function Method({data, lg, md, lm, ...props}) {
  if (typeof data === 'string') {
    return <ImageLayer {...props} src={data} />;
  } else {
    return (
      <Cards {...props} data={data} lg={lg} md={md} lm={lm}>
        <MethodCard />
      </Cards>
    );
  }
}

const TITLE = {
  transport: '云恋科技-网络货运平台解决方案',
  logistics: '云恋科技-综合物流服务解决方案',
  finance: '云恋科技-供应链金融解决方案',
};

function Solution({params: {path}}) {
  if (!global.isServer) {
    document.title = TITLE[path];
  }
  const {banner, method, advantage} = data[path];
  return (
    <App className='Solution' key={path}>
      <SolutionBanner data={banner} />
      <Method title='解决方案' data={method} lg={3} md={2} lm={2} size='middle' />
      <Cards title='方案优势' data={advantage} md={2} size='middle' grey>
        <AdvantageCard />
      </Cards>
    </App>
  );
}

export default Solution;



// WEBPACK FOOTER //
// ./src/routes/Solution/Solution.js